import type { ImageLoaderProps } from "next/image";

export default function imageLoader({ src, width, quality }: ImageLoaderProps) {
	if (isStoryblokDomain(src)) {
		src = src.replace(
			"https://a.storyblok.com",
			"https://assets.hbm-machines.com",
		);
	}

	if (supportsStoryblokImageModifications(src)) {
		let result = `${src}/m/${width}x0`;
		if (quality) {
			// Quality filter only needs to be added when explicitly defined,
			// since our CloudFlare worker will add filters:quality(80) by default
			result += `/filters:quality(${quality})`;
		}

		return result;
	}
	return src;
}

function supportsStoryblokImageModifications(src: string) {
	return (
		!src.endsWith(".svg") &&
		(isStoryblokDomain(src) || isCustomAssetsDomain(src))
	);
}

function isStoryblokDomain(src: string) {
	return src.startsWith("https://a.storyblok.com");
}

function isCustomAssetsDomain(src: string) {
	return (
		src.startsWith("https://assets.hbm-machines.it") ||
		src.startsWith("https://assets.hbm-machines.com")
	);
}
